const getNav = () => document.getElementById("header-nav-bar");

export const setNavDark = () => {
  const nav = getNav();
  if (nav) {
    nav.classList.add("dark");
  }
};
export const setNavLight = () => {
  const nav = getNav();
  if (nav) {
    nav.classList.remove("dark");
  }
};
